import { render, staticRenderFns } from "./CBPagination.vue?vue&type=template&id=52c590c4&scoped=true"
import script from "./CBPagination.vue?vue&type=script&lang=js"
export * from "./CBPagination.vue?vue&type=script&lang=js"
import style0 from "./CBPagination.vue?vue&type=style&index=0&id=52c590c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c590c4",
  null
  
)

export default component.exports